import type { Option } from "@src/lib/ui/toggleOption";
import FileOutlineIcon from "@src/lib/icons/18px/file-outline";
import MobileOutlineIcon from "@src/lib/icons/18px/mobile-outline";
import { useMemo } from "react";
import { createEnumParam, useQueryParam, withDefault } from "use-query-params";

export type TrainingResourceViewMode = "document-view" | "mobile-view";

export const TRAINING_RESOURCE_VIEW_MODE_OPTIONS: Option<TrainingResourceViewMode>[] =
  [
    {
      label: "Document",
      value: "document-view",
      icon: <FileOutlineIcon className="size-4" />,
    },
    {
      label: "Mobile",
      value: "mobile-view",
      icon: <MobileOutlineIcon className="size-4" />,
    },
  ];

type Return = {
  trainingResourceViewMode: TrainingResourceViewMode | null | undefined;
  setTrainingResourceViewMode: (value: TrainingResourceViewMode) => void;
};

const useTrainingResourceViewModeQueryParams = (): Return => {
  const [trainingResourceViewMode, setTrainingResourceViewMode] = useQueryParam(
    "training-resource-view-mode",
    withDefault(
      createEnumParam(TRAINING_RESOURCE_VIEW_MODE_OPTIONS.map((x) => x.value)),
      "document-view",
    ),
  );
  return useMemo(() => {
    return { trainingResourceViewMode, setTrainingResourceViewMode };
  }, [trainingResourceViewMode, setTrainingResourceViewMode]);
};

export default useTrainingResourceViewModeQueryParams;
